export default angular
  .module("AliasService", [])
  .factory("Aliases", [
    "$http",
    "$rootScope",
    "$filter",
    "Flash",
    function ($http, $rootScope, $filter, Flash) {
      const aliases = [];
      const loading = {
        aliases: false,
        alias: false,
        measurement: false,
      };

      // create a new Alias and persist it
      const addAlias = (callback) => {
        const params = {
          ALIAS_NAME: `new-alias-${(new Date()).getTime()}`,
        };
        $http
          .post("/api/aliases", params)
          .then(
            (res) => {
              const successMessage = `New alias created, ID: ${res.data.id}`;
              Flash.create("success", successMessage, "basicAlert");
              callback(res.data, res.status);
            },
            (res) => {
              if (res.status === 409) {
                const warningMessage = "Conflict! Alias with the same name already exists. Update aborted!";
                Flash.create("warning", warningMessage, "basicAlert");
              } else {
                const errorMessage = `Error! Updating alias failed. Error code: ${res.status}`;
                Flash.create("danger", errorMessage, "basicAlert");
              }
              callback(res.data, res.status);
            },
          );
      };

      // Load all aliases from the database
      const loadAliases = ({ page, limit, filter }, callback) => {
        loading.aliases = true;
        $http
          .get(`/api/aliases?limit=${limit}&offset=${(page - 1) * limit}${filter ? `&filter=${filter}` : ""}`)
          .success((data, status) => {
            // For change notification and 2-way binding
            angular.copy(data.rows, aliases);
            if (callback) {
              callback(status, data.count);
            }
          })
          .error((data, status) => {
            // display error message to user
            const errorMessage = `Error! ${data.errortext} Error code: ${status}`;
            Flash.create("danger", errorMessage, "basicAlert");

            if (callback) {
              callback(status);
            }
          }).finally(() => {
            loading.aliases = false;
          });
      };

      // Load an Alias by a given id
      const loadAliasById = (id, callback) => {
        loading.alias = true;
        $http
          .get(`/api/aliases/${id}`)
          .success((data, status) => {
            if (callback) {
              callback(data, status);
            }
          })
          .error((data, status) => {
            // Show error message to a user
            const errorMessage = `Error! ${data.errortext} Error code: ${status}`;
            Flash.create("danger", errorMessage, "basicAlert");

            if (callback) {
              callback(data, status);
            }
          })
          .finally(() => { loading.alias = false; });
      };

      // Update an Alias
      const updateAlias = (alias, callback) => {
        $http
          .put("/api/aliases", alias)
          .success((data, status) => {
            const successMessage = `Updated alias, Id: ${data.aliasId}`;
            Flash.create("success", successMessage, "basicAlert");
            if (callback) {
              callback(data, status);
            }
          })
          .error((data, status) => {
            if (status === 409) {
              const warningMessage = "Conflict! Alias with the same name already exists. Update aborted!";
              Flash.create("warning", warningMessage, "basicAlert");
            } else {
              const errorMessage = `Error! Updating alias failed. Error code: ${status}`;
              Flash.create("danger", errorMessage, "basicAlert");
            }

            if (callback) {
              callback(data, status);
            }
          })
          .finally(() => {});
      };

      // Update a measurement by a given Alias id
      const updateMeasurementByAliasId = (aliasId, measurement, callback) => {
        $http
          .put(`/api/aliases/${aliasId}/measurement`, measurement)
          .success((data, status) => {
            const successMessage = `Updated measurement, Id: ${data.measurementId}`;
            Flash.create("success", successMessage, "basicAlert");
            if (callback) {
              callback(data, status);
            }
          })
          .error((data, status) => {
            const errorMessage = `Error! Updating measurement failed. Error code: ${status}`;
            Flash.create("danger", errorMessage, "basicAlert");
            if (callback) {
              callback(data, status);
            }
          })
          .finally(() => {});
      };

      // Delete Alias by a given id
      const deleteAliasById = (id, callback) => {
        $http
          .delete(`/api/aliases/${id}`)
          .then(
            () => {
              const successMessage = "Remove successful for alias";
              Flash.create("success", successMessage, "basicAlert");
              if (callback) {
                callback();
              }
            },
            (res) => {
              const errorMessage = `Error! Removing alias failed with error code: ${res.status}`;
              Flash.create("danger", errorMessage, "basicAlert");
              if (callback) {
                callback();
              }
            },
          );
        if (callback) {
          callback();
        }
      };

      // Load a Measurement by a given Alias id
      const loadMeasurementByAliasId = (id, callback) => {
        loading.measurement = true;
        $http
          .get(`/api/aliases/${id}/measurement`)
          .success((data, status) => {
            if (callback) {
              callback(data, status);
            }
          })
          .error((data, status) => {
            // Show error message to a user
            if (status === 500) {
              const errorMessage = `Error! ${data.errortext} Error code: ${status}`;
              Flash.create("danger", errorMessage, "basicAlert");
            }

            if (callback) {
              callback(data, status);
            }
          })
          .finally(() => { loading.measurement = false; });
      };

      return {
        addAlias,
        getAliases: aliases,
        loading,
        loadAliases,
        loadAliasById,
        deleteAliasById,
        loadMeasurementByAliasId,
        updateAlias,
        updateMeasurementByAliasId,
      };
    },
  ]);
